// TD-762 — the app-side half of the boot watchdog.
//
// The watchdog itself is an inline, classic, non-deferred <script> in index.html: the failure
// it exists for is "the module bundle never arrives", and a watchdog shipped inside that bundle
// could not fire for it. See the commented block in apps/web/index.html for the measurement and
// the placement argument.
//
// This module is the DISARM side. It is called from AppAuthGate's mount effect — the root gate,
// which mounts on every branch (splash, signed-out, app shell) — so the signal means
// "React committed and painted something", not "auth succeeded". A slow-but-successful boot
// therefore disarms the watchdog instead of tripping it.
//
// Absence is a valid state, not an error: index.html is not the document under vitest/jsdom, and
// a client fork could serve its own shell. The optional call is the contract — there is nothing
// to disarm, and nothing to report.

declare global {
  interface Window {
    /** Installed by the inline boot watchdog in index.html. Absent under test / a custom shell. */
    __bennieBootWatchdog?: { cancel: () => void };
  }
}

/** Disarm the index.html boot watchdog. Idempotent — StrictMode double-invokes mount effects. */
export function cancelBootWatchdog(): void {
  window.__bennieBootWatchdog?.cancel();
}
